import React from "react";
import { Tabs } from "antd";
import { FONT } from "constants/index";

import TrainningBootAqua from "./trainning-boot-aqua";
import TrainningAqua from "./trainning-aqua";

const TrainningClientAqua = () => {
  const items = [
    {
      label: `Adulto`,
      key: "boot",
      children: <TrainningBootAqua />,
    },
    {
      label: `Kids`,
      key: "metodo",
      children: <TrainningAqua />,
    },
  ];

  return (
    <Tabs
      defaultActiveKey="1"
      centered
      size="large"
      style={{ fontFamily: FONT }}
      items={items}
    />
  );
};
export default TrainningClientAqua;
